import React from 'react';
import style from './UnitSelector.module.css';

export type ValueUnit = 'DOLLARS' | 'POINTS' | 'TICKS';

const LABELS: Record<ValueUnit, string> = {
  DOLLARS: '$',
  POINTS: 'pts',
  TICKS: 'tks',
};

interface UnitSelectorProps {
  value: ValueUnit;
  onChange: (unit: ValueUnit) => void;
  disabled?: boolean;
}

export const UnitSelector: React.FC<UnitSelectorProps> = ({ value, onChange, disabled }) => {
  const units: ValueUnit[] = ['DOLLARS', 'POINTS', 'TICKS'];
  return (
    <div className={`${style.group} ${disabled ? style.disabled : ''}`}>
      {units.map((unit) => (
        <button
          key={unit}
          className={`${style.option} ${value === unit ? style.selected : ''}`}
          onClick={() => onChange(unit)}
          type="button"
          disabled={disabled}
          title={unit.charAt(0) + unit.slice(1).toLowerCase()}
        >
          {LABELS[unit]}
        </button>
      ))}
    </div>
  );
};
